import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ApplicationState } from "./store";
import configureStore from "./store/configureStore";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import "./utilities/polyfills";
import ErrorBoundary from "./components/controls/errorBoundary";

export const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState as ApplicationState;
const store = configureStore(history, initialState);

function renderApp(App: any) {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ConnectedRouter>
    </Provider>,
    document.getElementById("root"),
  );
}

renderApp(App);

// Allow Hot Module Replacement
if ((module as any).hot) {
  (module as any).hot.accept("./App.tsx", () => {
    //routes = require<typeof RoutesModule>('./routes').routes;
    const NextApp = require("./App").default;
    renderApp(NextApp);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
